import { getAxiosNotif, getAxiosTotall } from "./ApiInstance"

/////////////////  Get Method  ////////////////////

export const getNewOrdersApi=(callback)=>{
    getAxiosTotall().get("orders/new/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getNewPeykRequestApi=(callback)=>{
    getAxiosTotall().get("delivery/new/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getCurrentPeykApi=(callback)=>{
    getAxiosTotall().get("delivery/current/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getDeliveredOrdersApi=async(from,to)=>{
    try{
        let exist=from ===null?`orders/delivered/`: `orders/delivered/?start_date=${from}&end_date=${to}`

        const result = await getAxiosTotall().get(exist)
        return result.data
    }catch(error){
        return error
    }
}

export const getDeliveringOrdersApi=(callback)=>{
    getAxiosTotall().get('orders/delivering/').then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getAllNewTaxiReqAPI=(callback)=>{
    getAxiosTotall().get('taxi/new/').then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getSupportListApi=(callback)=>{
    getAxiosTotall().get('support/').then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getMessageListApi=(id,callback)=>{
    getAxiosTotall().get(`support/${id}`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getDeliveryInfoApi=(callback)=>{
    getAxiosTotall().get('info/').then(response=>{
        if (response.data && response.data.status === -2) {
            localStorage.clear()
            window.location.reload()
          }
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}



export const getAcountinListApi=async() => {
    try{
        const result =await getAxiosTotall().get('accounting/all/');
        return result.data;
    }catch (error){
        return error;
    }
}
export const getWalletApi=async() => {
    try{
        const result =await getAxiosTotall().get('accounting/wallet/');
        return result.data;
    }catch (error){
        return error;
    }
}
export const getAvailibilityApi=async() => {
    try{
        const result =await getAxiosTotall().get('info/availability/');
        return result.data;
    }catch (error){
        return error;
    }
}
/////////////////  Post Method  ////////////////////

export const postSupportMessage=(info, callback)=>{
    getAxiosTotall().post("support/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
}
export const postFeedBackApi=(info, callback)=>{
    getAxiosTotall().post("support/feedback/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
}
export const confirmPhoneApi=(info, callback)=>{
    getAxiosTotall().post("login/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
}
export const confirmCodeApi=(info, callback)=>{
    getAxiosTotall().post("login/verification/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
}
export const setDeliveryTimeApi=(info, callback)=>{
    getAxiosTotall().post("orders/new/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const setDeliveringTimeApi=(info, callback)=>{
    getAxiosTotall().post("orders/delivering/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const setDeliveredApi=(info, callback)=>{
    getAxiosTotall().post("orders/delivered/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const sendNotifInfo=(info, callback)=>{
    getAxiosNotif().post("fcm/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const logOutApi=(info, callback)=>{
    getAxiosTotall().post("logout/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const cashOutFoodApi=(info, callback)=>{
    getAxiosTotall().post("accounting/cashout/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const sendAvailibilityPostApi=(info, callback)=>{
    getAxiosTotall().post("info/availability/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const TaxiReqApi=(info, callback)=>{
    getAxiosTotall().post("taxi/travels/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const DeliveryRequestAccesptApi=(info, callback)=>{
    getAxiosTotall().post("delivery/request/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const getFinishedRequestApi=( callback)=>{
    getAxiosTotall().get("delivery/finished/").then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const TaxiCurrentAPI=( callback)=>{
    getAxiosTotall().get("taxi/current/").then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}

export const TaxiFinishedTravelApi=( callback)=>{
    getAxiosTotall().get("taxi/finished/").then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
////////////////Live Location/////////////////////
export const liveLocationPostApi=(info, callback)=>{
    getAxiosTotall().post("orders/location/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}